var atp = atp || {
	Observer : function(update) {
		this.update = update;
	},
	Observable : function() {
			

		var observers = [],
			self = this,
			hasChanged = false;

		
		this.addObserver = function(observer) {
			if (observers.indexOf(observer) == -1)
				observers.push(observer);
		};

		
		this.deleteObserver = function(observer) {
			var index = observers.indexOf(observer);
			if (index != -1)
				observers.splice(index, 1);
		};

		
		this.notifyObservers = function() {
			if (self.hasChanged()) {
				for (var i = 0; i < observers.length; i++)
					observers[i].update();
				self.clearChanged();
			}
		};

		
		this.hasChanged = function() {
			return hasChanged;
		};

		
		this.setChanged = function() {
			hasChanged = true;
		};

		
		this.clearChanged = function() {
			hasChanged = false;
		};

	},
	Stack : function() {
		var linkedList = null;
		this.push = function(item) {
			linkedList = new atp.Node(item, linkedList);
		};
		this.pop = function() {
			var out = linkedList.data;
			linkedList = linkedList.next;
			return out;
		};
		this.peek = function() {
			return linkedList.data;
		};
		this.isEmpty = function() {
			return !linkedList || linkedList.data == null;
		};
	},
	Node: function(data, next) {
		this.data = data;
		this.next = next;
	},
	status: {
		DISABLED: 1,
		HOURS:    2,
		MINUTES:  3
	}
};
(function(atp){

	var singletonClass=function() {
		var self = this;

		
		var hours = 0;

		
		var minutes = 0;

		
		this.getMinutes = function() {
			return minutes;
		};

		
		this.getHours = function() {
			return hours;
		};

		
		this.getStatus = function() {
			return status;
		};

		
		this.setMinutes = function(n) {
			if (minutes!=n)
				self.setChanged();
			minutes = n;
			self.notifyObservers();
		};

		
		this.setHours = function(n) {
			if (hours!=n)
				self.setChanged();
			hours = n;
			self.notifyObservers();
		};

	};

	//singeltonClass now extends Observable
	singletonClass.prototype=new atp.Observable;
	singletonClass.constructor=singletonClass;
	atp.state=new singletonClass;

})(atp);
(function(atp){
	var flexEase=function(t) {
		if (t<1/2)
			return (-1/8)*Math.sin(t*Math.PI*2);
		else
			return t*2 - 1;
	};

	var animate=function(opts){
		var step=0, differences={};
		var easing=opts.easing||function(t){return t};
		var styles=opts.styles;
		var element=opts.element;
		var callback=opts.callback;
		var duration=opts.duration;
		var steps=duration/10;
		if (duration===0){
			for (var k in styles)
				if (styles.hasOwnProperty(k))
					element.css(k, styles[k][1]+styles[k][2]);
			if (callback)
				callback();
			return;
		}
		for (var k in styles)
			if (styles.hasOwnProperty(k))
				differences[k]=styles[k][1]-styles[k][0];

		var stepFn=function(){
			var factor=easing(step/steps);
			for (var k in styles)
				if (styles.hasOwnProperty(k))
					element.css(k, (styles[k][0]+differences[k]*factor)+styles[k][2]);
			if (++step>steps){
				clearInterval(interval);
				if (callback)
					callback();
			}
		};
		stepFn();
		var interval=setInterval(stepFn, duration/steps);
	};

	atp.animate=animate;
	atp.animate.easing={
		flex:flexEase
	};
	
})(atp);
/* abstract class atp.ux */
(function(atp){

	var timePromise={}, element, pluginElements, tracking, touched, isAm;
	var statusNow=atp.status.DISABLED;

	document.addEventListener('DOMContentLoaded', function(){
		var plugin=makeTemplate();
		document.body.appendChild(plugin);
		bindToElement(plugin);
	});

	var makeTemplate=function(){
		
		var template=
		'<div class="atp">'+
		'	<div class="atp-current">'+
		'		<span class="atp-current-hours selected">12</span>'+
		'		<span class="atp-current-seperator">:</span>'+
		'		<span class="atp-current-minutes">00</span>'+
		'		<span class="atp-current-am-pm">AM</span>'+
		'	</div>'+
		'	<div class="atp-clock">'+
		'		<div class="atp-hand"></div>'+
		'		<div class="atp-hours">'+
		'			<div class="atp-num atp-num-top-0 atp-num-left-3">12</div>'+
		'			<div class="atp-num atp-num-top-1 atp-num-left-4">1</div>'+
		'			<div class="atp-num atp-num-top-2 atp-num-left-5">2</div>'+
		'			<div class="atp-num atp-num-top-3 atp-num-left-6">3</div>'+
		'			<div class="atp-num atp-num-top-4 atp-num-left-5">4</div>'+
		'			<div class="atp-num atp-num-top-5 atp-num-left-4">5</div>'+
		'			<div class="atp-num atp-num-top-6 atp-num-left-3">6</div>'+
		'			<div class="atp-num atp-num-top-5 atp-num-left-2">7</div>'+
		'			<div class="atp-num atp-num-top-4 atp-num-left-1">8</div>'+
		'			<div class="atp-num atp-num-top-3 atp-num-left-0">9</div>'+
		'			<div class="atp-num atp-num-top-2 atp-num-left-1">10</div>'+
		'			<div class="atp-num atp-num-top-1 atp-num-left-2">11</div>'+
		'		</div>'+
		'		<div class="atp-minutes">'+
		'			<div class="atp-num atp-num-top-0 atp-num-left-3">0</div>'+
		'			<div class="atp-num atp-num-top-1 atp-num-left-4">5</div>'+
		'			<div class="atp-num atp-num-top-2 atp-num-left-5">10</div>'+
		'			<div class="atp-num atp-num-top-3 atp-num-left-6">15</div>'+
		'			<div class="atp-num atp-num-top-4 atp-num-left-5">20</div>'+
		'			<div class="atp-num atp-num-top-5 atp-num-left-4">25</div>'+
		'			<div class="atp-num atp-num-top-6 atp-num-left-3">30</div>'+
		'			<div class="atp-num atp-num-top-5 atp-num-left-2">35</div>'+
		'			<div class="atp-num atp-num-top-4 atp-num-left-1">40</div>'+
		'			<div class="atp-num atp-num-top-3 atp-num-left-0">45</div>'+
		'			<div class="atp-num atp-num-top-2 atp-num-left-1">50</div>'+
		'			<div class="atp-num atp-num-top-1 atp-num-left-2">55</div>'+
		'		</div>'+
		'		<div class="atp-middle-dot"></div>'+
		'		<div class="atp-cover"></div>'+
		'	</div>'+
		'	<div class="atp-am-pm">'+
		'		<div class="atp-am-select selected">'+
		'			<div>AM</div>'+
		'		</div>'+
		'		<div class="atp-pm-select">'+
		'			<div>PM</div>'+
		'		</div>'+
		'	</div>'+
		'	<div class="atp-buttons">'+
		'		<button class="atp-button atp-button-cancel">cancel</button>'+
		'		<button class="atp-button atp-button-ok">ok</button>'+
		'	</div>'+
		'</div>';
		var div=document.createElement('div');
		div.innerHTML=template.replace(/\t/g, '');
		return div.firstChild;
	};

	var refreshView=function(){

		var hours=atp.state.getHours();
		var minutes=atp.state.getMinutes();

		pluginElements.current.hours.html(
			(hours%12)==0?12:(hours%12)
		);

		pluginElements.current.minutes.html(
			formatNumber(minutes)
		);

		pluginElements.current.ampm.html(
			hours>=12?"PM":"AM"
		);

		if (hours>=12){
			pluginElements.buttons.pm.addClass('selected');
			pluginElements.buttons.am.removeClass('selected');
		}
		else {
			pluginElements.buttons.am.addClass('selected');
			pluginElements.buttons.pm.removeClass('selected');
		}

		switch (getStatus()){
			case atp.status.HOURS:
				pluginElements.current.hours.addClass('selected');
				pluginElements.current.minutes.removeClass('selected');
				pluginElements.clock.hand.css({
					transform:'rotate('+((hours%12)*30)+'deg)'
				});
				break;
			case atp.status.MINUTES:
				pluginElements.current.minutes.addClass('selected');
				pluginElements.current.hours.removeClass('selected');
				pluginElements.clock.hand.css({
					transform:'rotate('+(minutes*6)+'deg)'
				});

		}

	};

	var observer=new atp.Observer(refreshView);

	atp.state.addObserver(observer);

	
	var start=function(){
		var element=this;
		var values=element.value.split(":");
		atp.state.setHours(parseInt(values[0])||0);
		atp.state.setMinutes(parseInt(values[1])||0);
		setAm(atp.state.getHours()<12);
		setStatus(atp.status.HOURS, true);
		alignPluginOn(element);
		pluginElements.main.css('display', 'block');

		(new Promise(function(resolve, reject){
			timePromise.resolve=resolve;
			timePromise.reject=reject;
		}))
		.then(function(value){
			element.value=value;
			dismiss();
		})
		.catch(function(){
			dismiss();
		});
	};

	var dismiss=function(){
		pluginElements.main.css('display', 'none');
		setStatus(atp.status.HOURS);
	};

	
	var getStatus=function(){ return statusNow };

	
	var setStatus=function(status, immediate){
		if (statusNow==status)
			return;
		statusNow=status;
		transition(immediate);
	};

	var transition=function(immediate){

		var duration=immediate?0:150;

		switch (getStatus()){
			case atp.status.MINUTES:
				atp.animate({
					element:pluginElements.clock.hours,
					styles:{
						width:[100, 125, '%'],
						height:[100, 125, '%'],
						top:[0, -12.5, '%'],
						left:[0, -12.5, '%'],
						opacity:[1, 0, '']
					},
					easing: atp.animate.easing.flex,
					duration: duration,
					callback: function(){
						pluginElements.clock.hours.css('display', 'none');
						refreshView();
						atp.animate({
							element:pluginElements.clock.minutes.css('display', 'block'),
							styles:{
								height:[50, 100, '%'],
								width:[50, 100, '%'],
								left:[25, 0, '%'],
								top:[25, 0, '%'],
								opacity:[0, 1, '']
							},
							duration:duration
						});
					}
				});
				break;
			case atp.status.HOURS:
				atp.animate({
					element:pluginElements.clock.minutes,
					styles:{
						width:[100, 50, '%'],
						height:[100, 50, '%'],
						top:[0, 25, '%'],
						left:[0, 25, '%'],
						opacity:[1, 0, '']
					},
					easing: atp.animate.easing.flex,
					duration: duration,
					callback: function(){
						pluginElements.clock.minutes.css('display', 'none');
						refreshView();
						atp.animate({
							element:pluginElements.clock.hours.css('display', 'block'),
							styles:{
								height:[125, 100, '%'],
								width:[125, 100, '%'],
								left:[-12.5, 0, '%'],
								top:[-12.5, 0, '%'],
								opacity:[0, 1, '']
							},
							duration: duration
						});
					}
				});
		}

	};

	var offset=function(element){

	    var rect=element.getBoundingClientRect(),
	    	offsetTop=rect.top,
	    	offsetLeft=rect.left;

	    return {
	    	top: offsetTop,
	    	left: offsetLeft
	    };
	}
	
	var alignPluginOn=function(element){
		if (!pluginElements)
			return;
		var pos=offset(element);
		pos.top+="px";
		pos.left+="px";
		pluginElements.main.css(pos);
	};

	
	var bindToElement=function(element){
		pluginElements={
			main:        atp.ux.jQuery(element),
			current:{
				hours:   atp.ux.jQuery(element.querySelector('.atp-current-hours')),
				minutes: atp.ux.jQuery(element.querySelector('.atp-current-minutes')),
				ampm:    atp.ux.jQuery(element.querySelector('.atp-current-am-pm'))
			},
			clock:{
				hours:   atp.ux.jQuery(element.querySelector('.atp-hours')),
				minutes: atp.ux.jQuery(element.querySelector('.atp-minutes')),
				face:    atp.ux.jQuery(element.querySelector('.atp-cover')),
				hand:    atp.ux.jQuery(element.querySelector('.atp-hand'))
			},
			buttons:{
				am:      atp.ux.jQuery(element.querySelector('.atp-am-select')),
				pm:      atp.ux.jQuery(element.querySelector('.atp-pm-select')),
				ok:      atp.ux.jQuery(element.querySelector('.atp-button-ok')),
				cancel:  atp.ux.jQuery(element.querySelector('.atp-button-cancel'))
			}
		};
		pluginElements.clock.face.on("click mousedown mousemove mouseup touchstart touchend touchmove touchcancel", clockEventHandler);
		pluginElements.buttons.ok.on('click', function(){
			timePromise.resolve(
				formatNumber(atp.state.getHours())+":"+
				formatNumber(atp.state.getMinutes())
			);
		});
		pluginElements.buttons.cancel.on('click', function(){
			timePromise.reject();
		});
		pluginElements.buttons.am.on('click', function(){
			setAm(true);
		});
		pluginElements.buttons.pm.on('click', function(){
			setAm(false);
		});
		pluginElements.current.hours.on("click", function(){
			setStatus(atp.status.HOURS);
		});
		pluginElements.current.minutes.on("click", function(){
			setStatus(atp.status.MINUTES);
		});

	};

	var setAm=function(am){

		if (am && atp.state.getHours()>=12)
			atp.state.setHours(atp.state.getHours()-12);
		else if (!am && atp.state.getHours()<12)
			atp.state.setHours(atp.state.getHours()+12);

		isAm=am;

	};

	var clockEventHandler=function(e){

		var next;
		switch (e.type){
			case "mousedown":
			case "touchstart":
				tracking=true;touched=true;
				break;
			case "mouseup":
			case "touchend":
			case "touchcancel":
				tracking=false;
			case "click":
				next=true;
		}
		if (e.type.indexOf("touch")!=-1 && !next){
			e.preventDefault();
			e.pageX=e.originalEvent.touches[0].pageX;
			e.pageY=e.originalEvent.touches[0].pageY;
		}
		if (next && touched){
			if (getStatus()===atp.status.HOURS){
				setStatus(atp.status.MINUTES);
			}
		}
		if (!tracking)
			return;

		var parentOffset = offset(this);
		//var _this=atp.ux.jQuery(this);

		var x = ((e.pageX - parentOffset.left)/this.getBoundingClientRect().width-.5)*2;
		var y = ((e.pageY - parentOffset.top)/this.getBoundingClientRect().height-.5)*-2;
		var distanceFromOrigin=Math.sqrt(x*x+y*y);
		if (distanceFromOrigin<.5)
			return;
		var factor=1/distanceFromOrigin;
		x*=factor;
		y*=factor;
		var theta=Math.atan2(y, x);
		if (theta<0)
			theta+=Math.PI*2;

		switch (getStatus()){
			case atp.status.HOURS:
				atp.state.setHours(
					fromRadians(theta, 12)+(isAm?0:12)
				);
				break;
			case atp.status.MINUTES: 
				atp.state.setMinutes(
					fromRadians(theta, 60)
				);
				break;
		}

	};

	var fromRadians=function(theta, of){

		var n=of;
		var q1=new atp.Stack();
		var q234=new atp.Stack();
		for (var i=0; i<n; i++){
			if (i/n<=.25)
				q1.push(i);
			else
				q234.push(i);
		}
		var order=[];
		while (!q1.isEmpty())
			order.push(q1.pop());
		while (!q234.isEmpty())
			order.push(q234.pop());

		var index=Math.round( (theta/(2*Math.PI)) * n );

		if (index==n)
			index=0;

		return order[index];

	};

	var formatNumber=function(n){
		return (n<10)?'0'+n:n;
	};

	atp.ux={
		'start':start
	};

})(atp);

angular.module("ngAtp", []).directive("ngAtp", ['$compile', function($compile){

	atp.ux.jQuery=angular.element;



	return function(scope, element, attrs){
	  if (Modernizr.inputtypes.time && isMobileOs()) {
      const date = scope.quote.dates[0] ? scope.quote.dates[0] : new Date()
      var html = element
                  .clone()
                  .removeAttr('ng-click data-ng-atp ng-value')
                  .attr('type','time')
                  .attr('ng-value', "(quote.dates[0] | date:'HH:mm':'+0000')")
                  [0].outerHTML 
      var replace = $compile(html)(scope)
      element.replaceWith(replace)
      replace.on('input', function() {
        var newdate = moment(scope.dates[0]).startOf('day').add(this.valueAsNumber,'ms')
        scope.dates[0] = newdate.toDate()
      })
      return
    }
    $('body').on('click', '.atp-button-ok', function() {
      scope.$apply(function($scope) {
        if (!$scope.dates) return;
        var date = new Date($scope.dates[0])
        date.setUTCMinutes(atp.state.getMinutes())
        date.setUTCHours(atp.state.getHours());
        $scope.dates[0] = date
      })
    })
		element.bind("focus", atp.ux.start);
	};
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./gulp/assets/javascripts/atp.js
 ** module id = 11
 ** module chunks = 0
 **/